// closing-misc-messages translations (English catalog).
window.PlummeI18n.register('en', {
  'r1c.postRef': '(item {code})',
  'r1c.addSuffix': ' item',
  'r1c.incomeBalanceNote': 'Changing figures here does not affect your actual accounts, only the tax return. If your accounts are wrong, you must reopen the accounts and correct them before you create a new draft of the tax return.',
});
